import useStatsigGate from 'modules/common/useStatsigGate';
import { FeatureGates } from 'modules/common/constants/featuregates';

/** The legacy self-service dashboard. Still home for anyone outside the v2 rollout. */
export const LEGACY_PAYROLL_HOME = '/payroll';

/** The native Overview. Home for anyone the `payroll_dashboard_v2` gate is on for. */
export const PAYROLL_OVERVIEW_HOME = '/payroll/overview';

/**
 * Where "back to payroll" goes for this member.
 *
 * `/payroll` sends a set-up member in the v2 rollout to `/payroll/overview`, but only after a
 * redirect, and a member who hasn't finished setup gets the setup screen there instead. Every
 * surface that sends someone back to payroll reads this instead of picking a path, so the
 * destination cannot drift per screen as the rollout moves.
 */
export default function usePayrollHomePath(): string {
    return useStatsigGate(FeatureGates.PayrollDashboardV2) ? PAYROLL_OVERVIEW_HOME : LEGACY_PAYROLL_HOME;
}
